import { useCallback } from 'react';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import {
  ANALYTICS_TABS,
  parseAnalyticsTab,
  type AnalyticsTab,
} from '@/lib/analytics-tabs';

const tabParser = parseAsStringLiteral(ANALYTICS_TABS).withOptions({
  history: 'replace',
});

/**
 * `?tab=` of the Analytics page (ANLT-01). Resumo is the absence of the
 * param: `setTab('overview')` and `setTab(null)` clear it, and a missing or
 * unknown value reads as `overview`.
 */
export function useAnalyticsTab(): {
  tab: AnalyticsTab;
  setTab: (tab: AnalyticsTab | null) => void;
} {
  const [raw, setRaw] = useQueryState('tab', tabParser);

  const setTab = useCallback(
    (next: AnalyticsTab | null) => {
      void setRaw(next === 'overview' ? null : next);
    },
    [setRaw]
  );

  return { tab: parseAnalyticsTab(raw), setTab };
}
